import React, { useState } from "react";
import Search from "../../components/Search";
import LeaderBoardHeader from "../../components/pages/LeaderBoard/LeaderBoardHeader";

export default function LeaderBoard() {
  const [searchTerm, setSearchTerm] = useState("");
  const [title, setTitle] = useState("All Time Participants");

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  function handleOnChangeTitle(changeTitle) {
    setTitle(changeTitle);
  }
  return (
    <>
      <div className="p-6 bg-white rounded-lg shadow-md m-3">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-8">
            <h1 className="text-[20px] font-bold text-[#400167]">{title}</h1>
            <Search onSearch={handleSearch} />
          </div>
        </div>
        <LeaderBoardHeader onChangeTitle={handleOnChangeTitle} />
      </div>
    </>
  );
}
